import React from "react";
import "./sectionTransition.css";

const SectionWrapper = ({ children }: { children: React.ReactNode }) => {
  return <section className="section-breath">{children}</section>;
};

export default SectionWrapper;